import { Checkbox } from "@nextui-org/react";
const categoriescolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "imageUrl",
    label: "Image",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "numberOfProducts",
    label: "Product Count",
  },
  
  
  {
    key: "actions",
    label: "Actions",
  },
];

export { categoriescolumn };
